import { IAny, ICoreContext, IGeneric } from '@msdyn365-commerce/core';

export function isPaymentTermValidationEnabled(context: ICoreContext<IGeneric<IAny>>): boolean {
    return !!context.app.config?.enablePaymentTermValidation;
}

export function getPaymentTermSubCategoryAttributeName(context: ICoreContext<IGeneric<IAny>>): string {
    return context.app.config?.paymentTermSubCategoryAttributeName;
}

export function getPaymentTermCustomerAttributePrefix(context: ICoreContext<IGeneric<IAny>>): string {
    return context.app.config?.paymentTermCustomerAttributePrefix;
}

export function getCustomerPaymentTermAttributeNames(customerAttributePrefix: string, category: string): string[] {
    const trimmedCategory = category?.trim();

    if (!trimmedCategory) {
        return [];
    }

    const original = trimmedCategory;
    const withoutSpaces = trimmedCategory.replace(/\s+/g, '');
    const withoutSpecialChars = trimmedCategory.replace(/[^a-zA-Z0-9]/g, '');

    return Array.from(
        new Set(
            [
                `${customerAttributePrefix}${original}`,
                `${customerAttributePrefix}${withoutSpaces}`,
                `${customerAttributePrefix}${withoutSpecialChars}`
            ].filter(Boolean)
        )
    );
}
